module.exports = __webpack_public_path__ + "static/media/sv.1f642770.svg";